"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _Paper = _interopRequireDefault(require("@mui/material/Paper"));

var _PriceDisplay = _interopRequireDefault(require("./PriceDisplay"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Subtotal = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Subtotal, _Component);

  var _super = _createSuper(Subtotal);

  function Subtotal() {
    (0, _classCallCheck2["default"])(this, Subtotal);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Subtotal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          minimumOrder = _this$props.minimumOrder,
          subtotal = _this$props.subtotal,
          tax = _this$props.tax;
      var subtotalWithMin = (parseFloat(minimumOrder) + parseFloat(subtotal.replace(',', ''))).toFixed(2); //Add ',' into subTotal if > "$1,000"

      if (subtotalWithMin.length > 6) {
        var findCommas = subtotalWithMin.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        subtotalWithMin = findCommas;
      }

      return /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
        style: {
          padding: '15px',
          marginBottom: '15px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_PriceDisplay["default"], {
        label: "Minimum Order",
        price: minimumOrder
      }), /*#__PURE__*/_react["default"].createElement(_PriceDisplay["default"], {
        label: "Sales Tax",
        price: tax
      }), /*#__PURE__*/_react["default"].createElement(_PriceDisplay["default"], {
        label: "Subtotal",
        price: subtotalWithMin
      }));
    }
  }]);
  return Subtotal;
}(_react.Component);

exports["default"] = Subtotal;